// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"5182d5fb","408":"e4fd5ac7","435":"954785fb","453":"d0cb4e05","583":"f5f8bc66","942":"193fefb1"}[chunkId] + ".chunk.js";
};